
import axios from './rest-axios';

const getStat1 = (begin_time, end_time) => axios.post(`/manage/stat/1`, {begin_time, end_time});
const getStat2 = (begin_time, end_time, nick_name) => axios.post(`/manage/stat/2`, {begin_time, end_time,nick_name});
const getStat3 = (begin_time, end_time) => axios.post(`/manage/stat/3`, {begin_time, end_time});
const getStat4 = (begin_time, end_time) => axios.post(`/manage/stat/4`, {begin_time, end_time});
const getStat5 = (end_time, store_id) => axios.post(`/manage/stat/5`, {end_time, store_id});
const getStat6 = (year) => axios.post(`/manage/stat/6`, {year});
const getStat7 = (year, store_id) => axios.post(`/manage/stat/7`, {year, store_id});
const getStatDate = (month) => axios.get(`/manage/stat_date`, {month});
const getStatDateDetail = (date) => axios.get(`/manage/stat_date/${date}`);
const getStatMonth = (year) => axios.get(`/manage/stat_month`, {year});
const getStatMonthDetail = (year, month) => axios.get(`/manage/stat_month/${year}/${month}`);
const getStatShouRu = (year) => axios.get(`/manage/stat_shouru`, {year});
const getStatShouRuDetail = (year, month) => axios.get(`/manage/stat_shouru/${year}/${month}`);
const getStatmapi = (begin_date, end_date) => axios.post(`/manage/stat/mapi`, {begin_date, end_date});


export {
    getStat1,
    getStat2,
    getStat3,
    getStat4,
    getStat5,
    getStat6,
    getStat7,
    getStatDate,
    getStatDateDetail,
    getStatMonth,
    getStatMonthDetail,
    getStatShouRu,
    getStatShouRuDetail,
    getStatmapi,
};
